const getFirstTwoLetters = (string) => {
    return string
        .split(' ')
        .map((item) => item[0])
        .join('')
        .substr(0, 2);
};

const getNestedObject = (object, path) => {
    if (!Array.isArray(path)) {
        throw Error('path must be an array');
    }
    return path.reduce((obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), object);
};

// const categoryId = '163378'; <-- Uma categoria de ajuda do SimplesCTe
// const appId = '203379134336512'; <-- ID do SimplesCTe
// https://web.freshchat.com/app/services/category/163378/article/602411/20?appId=203379134336512
const getFreshChatLink = (articleId, categoryId, appId) => `https://web.freshchat.com/app/services/category/${categoryId}/article/${articleId}/20?appId=${appId}`;

const hasKey = (obj, key) => key in obj;

const isValueNil = (values) => {
    const keys = Object.keys(values);
    for (let index = 0; index < keys.length; index += 1) {
        const acc = keys[index];
        if (values[acc] === null || values[acc] === undefined) {
            return true;
        }
    }
    return false;
};

/**
 * Da string passada, faz com que a primeira letra se comporte como
 * UPPER CASE.
 *
 * Observe que, quando o tipo de valor passado é um number, ele é
 * imediatamente retornado como uma string vazia.
 * @param data A string (ou `number`) que irá se transformar em capitalized.
 */
const capitalize = (data) => {
    if (!data) {
        return '';
    }
    if (typeof data === 'number' || !data.length) {
        return '';
    }
    if (data.length === 1) {
        return data.toUpperCase();
    }
    return data.charAt(0).toUpperCase() + data.slice(1);
};

/**
 * Helper to use Object.keys, and have no type errors.
 */
function keys(obj) {
    return Object.keys(obj);
}

// @ts-nocheck
const parseEnvolvido = (env, ender) => {
    if (!env || !ender)
        return;
    let cpf_cnpj = getNestedObject(env, ['CPF', '_text'])
        ? getNestedObject(env, ['CPF', '_text'])
        : getNestedObject(env, ['CNPJ', '_text']);
    if (getNestedObject(ender, ['cMun', '_text']) === '9999999') {
        cpf_cnpj = '00000000000000';
    }
    return {
        tipo_pessoa: getNestedObject(env, ['CPF', '_text']) ? 0 : 1,
        cpf_cnpj: cpf_cnpj,
        im: getNestedObject(env, ['IM', '_text']),
        cnae: getNestedObject(env, ['cnae', '_text']),
        ie: getNestedObject(env, ['IE', '_text']),
        indicador_ie: getNestedObject(env, ['IE', '_text']) ? (env.toext == 'ISENTO' ? 2 : 1) : 9,
        iest: getNestedObject(env, ['IEST', '_text']),
        razao_social: getNestedObject(env, ['xNome', '_text']),
        nome: getNestedObject(env, ['xNome', '_text']),
        nome_fantasia: getNestedObject(env, ['xFant', '_text']),
        fone: getNestedObject(env, ['fone', '_text']),
        email: getNestedObject(env, ['email', '_text']),
        end_rua: getNestedObject(ender, ['xLgr', '_text']),
        end_numero: getNestedObject(ender, ['nro', '_text']),
        end_bairro: getNestedObject(ender, ['xBairro', '_text']),
        complemento: getNestedObject(ender, ['xCpl', '_text']),
        codigo_cidade: getNestedObject(ender, ['cMun', '_text']),
        cidade: getNestedObject(ender, ['xMun', '_text']),
        uf: getNestedObject(ender, ['UF', '_text']),
        end_cep: getNestedObject(ender, ['CEP', '_text']),
        imported: true,
        cliente: 1,
        fornecedor: 0,
        motorista: 0,
        transportadora: 0,
        proprietario_veiculo: 0,
        suframa: getNestedObject(env, ['ISUF', '_text']),
        end_codigo_pais: getNestedObject(ender, ['cPais', '_text']),
        end_pais_nome: getNestedObject(ender, ['xPais', '_text'])
    };
};
function treatNFe(raw) {
    if (raw.CTe || raw.cteProc) {
        return {
            error: 'O arquivo não corresponde a um XML de Nota Fiscal Eletrônica, se você quer gerar um CT-e de redespacho selecione na tela anterior a opção CT-e de outra transportadora.'
        };
    }
    if (raw.NFe || raw.nfeProc || raw['nm:nfeProc']) {
        let infNFe;
        if (raw['nm:nfeProc']) {
            infNFe = raw['nm:nfeProc']['NFe'].infNFe;
        }
        else {
            if (raw.NFe) {
                infNFe = raw.NFe.infNFe;
            }
            else if (raw.nfeProc) {
                infNFe = raw.nfeProc.NFe.infNFe;
            }
            else {
                return { error: 'Arquivo não suportado.' };
            }
        }
        if (getNestedObject(infNFe, ['_attributes', 'versao']) !== '4.00')
            return { error: 'Versão de NF-e não suportado.' };
        if (getNestedObject(infNFe, ['dest', 'CPF', '_text']) &&
            !validarCPF(getNestedObject(infNFe, ['dest', 'CPF', '_text'])))
            return { error: 'Essa NF-e contém um CPF inválido no destinatário.' };
        if (getNestedObject(infNFe, ['dest', 'CNPJ', '_text']) &&
            !ValidateCNPJ(getNestedObject(infNFe, ['dest', 'CNPJ', '_text'])))
            return { error: 'Essa NF-e contém um CNPJ inválido no destinatário.' };
        if (getNestedObject(infNFe, ['emit', 'CPF', '_text']) &&
            !validarCPF(getNestedObject(infNFe, ['emit', 'CPF', '_text'])))
            return { error: 'Essa NF-e contém um CPF inválido no emitente.' };
        if (getNestedObject(infNFe, ['emit', 'CNPJ', '_text']) &&
            !ValidateCNPJ(getNestedObject(infNFe, ['emit', 'CNPJ', '_text'])))
            return { error: 'Essa NF-e contém um CNPJ inválido no emitente.' };
        let doc = {
            chave_acesso: infNFe._attributes.Id.replace('NFe', ''),
            numero: infNFe.ide.nNF._text,
            serie: infNFe.ide.serie._text,
            envolvidos: {
                dest: infNFe.ide.tpNF._text == '1' || infNFe.ide.tpNF._text == '0'
                    ? parseEnvolvido(infNFe.dest, infNFe.dest.enderDest)
                    : parseEnvolvido(infNFe.emit, infNFe.emit.enderEmit),
                emit: infNFe.ide.tpNF._text == '1' || infNFe.ide.tpNF._text == '0'
                    ? parseEnvolvido(infNFe.emit, infNFe.emit.enderEmit)
                    : parseEnvolvido(infNFe.dest, infNFe.dest.enderDest)
            },
            valor_total: getNestedObject(infNFe, ['total', 'ICMSTot', 'vNF', '_text']),
            valor_pago: getNestedObject(infNFe, ['pag', 'detPag', 'vPag', '_text']),
            valor_frete: getNestedObject(infNFe, ['total', 'ICMSTot', 'vFrete', '_text']),
            valor_bc_icms: getNestedObject(infNFe, ['total', 'ICMSTot', 'vBC', '_text']),
            valor_total_tributo: getNestedObject(infNFe, ['total', 'ICMSTot', 'vTotTrib', '_text'])
        };
        // Ordens Do Andre card CTE-228 !!ACHO QUE VAI QUEBRAR
        if (doc.envolvidos.emit.ie === undefined) {
            doc.envolvidos.emit = undefined;
        }
        //----------|||--------|||--------||||-----
        if (infNFe.det) {
            const { det } = infNFe;
            if (Array.isArray(det)) {
                doc.produto = det.map((e) => ({
                    nome_produto: (getNestedObject(e, ['prod', 'xProd', '_text']) || '').slice(0, 60),
                    valor_produto: getNestedObject(e, ['prod', 'vProd', '_text']),
                    quant_produto: getNestedObject(e, ['prod', 'qCom', '_text']),
                    unidade_produto: getNestedObject(e, ['prod', 'uTrib', '_text'])
                }));
            }
            else {
                doc.produto = [
                    {
                        nome_produto: (getNestedObject(det, ['prod', 'xProd', '_text']) || '').slice(0, 60),
                        valor_produto: getNestedObject(det, ['prod', 'vProd', '_text']),
                        quant_produto: getNestedObject(det, ['prod', 'qCom', '_text']),
                        unidade_produto: getNestedObject(det, ['prod', 'uTrib', '_text'])
                    }
                ];
            }
        }
        if (infNFe.transp.vol) {
            doc.cargas = {};
            if (infNFe.transp.vol) {
                doc.cargas.peso_bruto = getNestedObject(infNFe, ['transp', 'vol', 'pesoB', '_text']);
                doc.cargas.peso_liquido = getNestedObject(infNFe, ['transp', 'vol', 'pesoL', '_text']);
                doc.cargas.tipo_unidade = getNestedObject(infNFe, ['transp', 'vol', 'esp', '_text']);
                //Pega dados da quantidade de volumes
                // verificar se e realmente esse obj, esta retornando a mesma
                // quantidade do peso_bruto
                doc.cargas.volumes = getNestedObject(infNFe, ['transp', 'vol', 'qVol', '_text']);
            }
            doc.cargas.modFrete = getNestedObject(infNFe, ['transp', 'modFrete', '_text']);
        }
        if (infNFe.transp.veicTransp) {
            doc.veiculo_placa = getNestedObject(infNFe, ['transp', 'veicTransp', 'placa', '_text']);
        }
        return doc;
    }
    else {
        return { error: 'Arquivo não suportado.' };
    }
}

function validarCPF(ref) {
    if (!ref)
        return;
    let cpf = ref.toString();
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '')
        return false;
    // Elimina CPFs invalidos conhecidos
    if (cpf.length != 11 ||
        cpf == '00000000000' ||
        cpf == '11111111111' ||
        cpf == '22222222222' ||
        cpf == '33333333333' ||
        cpf == '44444444444' ||
        cpf == '55555555555' ||
        cpf == '66666666666' ||
        cpf == '77777777777' ||
        cpf == '88888888888' ||
        cpf == '99999999999') {
        return false;
    }
    // Valida 1o digito
    let add = 0;
    let i = 0;
    for (i; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9))) {
        return false;
    }
    // Valida 2o digito
    add = 0;
    for (i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(cpf.charAt(10))) {
        return false;
    }
    return true;
}

function ValidateCNPJ(CNPJ) {
    if (!CNPJ)
        return;
    CNPJ = CNPJ.replace(/[^\d]+/g, '');
    if (CNPJ == '')
        return false;
    if (CNPJ.length != 14) {
        return false;
    }
    // Elimina CNPJs invalidos conhecidos
    if (CNPJ == '00000000000000' ||
        CNPJ == '11111111111111' ||
        CNPJ == '22222222222222' ||
        CNPJ == '33333333333333' ||
        CNPJ == '44444444444444' ||
        CNPJ == '55555555555555' ||
        CNPJ == '66666666666666' ||
        CNPJ == '77777777777777' ||
        CNPJ == '88888888888888' ||
        CNPJ == '99999999999999') {
        return false;
    }
    let tamanho = CNPJ.length - 2;
    let numeros = CNPJ.substring(0, tamanho);
    const digitos = CNPJ.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let index = tamanho; index >= 1; index--) {
        soma += parseInt(numeros.charAt(tamanho - index)) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(0))) {
        return false;
    }
    tamanho = tamanho + 1;
    numeros = CNPJ.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let index = tamanho; index >= 1; index--) {
        soma += parseInt(numeros.charAt(tamanho - index)) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != parseInt(digitos.charAt(1))) {
        return false;
    }
    return true;
}

function index (CNH) {
    if (CNH == null) {
        return false;
    }
    CNH = CNH.replace(/\//g, '').replace(/-/g, '').replace(/\./g, '').replace(/ /g, '');
    if (CNH.length != 11) {
        return false;
    }
    let parcial = CNH.substring(0, 9);
    let soma = 0;
    for (let i = 0, j = 2; i < parcial.length; i++, j++) {
        soma += parcial.charAt(i) * j;
    }
    let dv1 = 0;
    let dv2 = 0;
    let resto = soma % 11;
    if (resto <= 1) {
        dv1 = 0;
    }
    else {
        dv1 = 11 - resto;
    }
    parcial = dv1.toString() + parcial;
    soma = 0;
    for (let i = 0, j = 2; i < parcial.length; i++, j++) {
        soma += parcial.charAt(i) * j;
    }
    resto = soma % 11;
    if (resto <= 1) {
        dv2 = 0;
    }
    else {
        dv2 = 11 - resto;
    }
    return dv1.toString() + dv2.toString() == CNH.substring(CNH.length - 2, CNH.length);
}

//@ts-nocheck
function validateChaveAcesso(value) {
    if (!value)
        return;
    if (value.length < 44 || value.length > 44)
        return;
    const chave = String(value);
    const multiplicadores = [2, 3, 4, 5, 6, 7, 8, 9];
    let i = 42;
    let soma = 0;
    let resto = 0;
    while (i >= 0) {
        for (let m = 0; m < multiplicadores.length && i >= 0; m++) {
            soma += parseInt(chave[i]) * parseInt(multiplicadores[m]);
            i--;
        }
    }
    resto = soma % 11;
    if (resto === 0 || resto === 1) {
        // return 0;
        if (chave[43] == 0)
            return true;
        return;
    }
    else {
        // return 11 - resto;
        if (chave[43] == 11 - resto)
            return true;
        return;
    }
}

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
function ValidateEmail(email) {
    if (Array.isArray(email)) {
        email.map((e) => {
            if (!emailRegex.test(e)) {
                return `O Email ${e} não é valido`;
            }
        });
    }
    else {
        if (!emailRegex.test(email)) {
            return `O Email ${email} não é valido`;
        }
    }
    return true;
}

const validateRenavam = (renavam) => {
    let soma;
    let digito;
    let x;
    let valor;
    const d = renavam.split('');
    (soma = 0), (valor = 0), (digito = 0), (x = 0);
    for (let i = 5; i >= 2; i--) {
        soma += d[x] * i;
        x++;
    }
    valor = soma % 11;
    if (valor == 11 || valor == 0 || valor >= 10) {
        digito = 0;
    }
    else {
        digito = valor;
    }
    if (digito == d[4]) {
        return false;
    }
    else {
        return true;
    }
};

/**
 * Converte um objeto File para base64
 */
const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
});

/**
 * Recebe um base64 que passou pelo processo de encoding e então o converte para
 * um arquivo (Blob).
 * @param base64 A string que passou pelo processo de encoded (comumente, é o
 *               back-end responsável pelo encoding.)
 * @param type  O tipo de encoding que fará com que a string seja transformada.
 *              Comumente, este valor corresponde ao tipo de arquivo, exemplo:
 *              "text/html".
 */
const base64ToBlob = (base64, type) => {
    const content = atob(base64);
    // TODO @leo_lemos Escrever teste unitário sobre esta func.
    const buffer = new ArrayBuffer(content.length);
    const view = new Uint8Array(buffer);
    for (let n = 0; n < content.length; n += 1) {
        view[n] = content.charCodeAt(n);
    }
    const blob = new Blob([buffer], { type });
    return blob;
};

function formatStr(string, maxLength = 25) {
    return String(string).length > maxLength ? String(string).substr(0, maxLength) + '...' : string;
}

function paddingLeft(value = '', length = 0, padValue = '0') {
    while (!(value.length === length)) {
        value = padValue + value;
    }
    return value;
}

const logToFile = (content, fileName, contentType) => {
    const a = document.createElement('a');
    const file = new Blob([JSON.stringify(content)], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
};

const sortAsc = (arg) => {
    if (!arg)
        return;
    return arg.sort((a, b) => {
        if (a.value < b.value)
            return -1;
        if (a.value > b.value)
            return 1;
        return 0;
    });
};
const sortDesc = (arg) => {
    if (!arg)
        return;
    return arg.sort((a, b) => {
        if (a.value < b.value)
            return 1;
        if (a.value > b.value)
            return -1;
        return 0;
    });
};
const between = (param, start, end) => {
    if (param >= start && param <= end) {
        return true;
    }
    else
        return false;
};

//@ts-nocheck
const checkEveryValueEqual = (object, defaultValue) => {
    return Object.values(object).every((value) => value === defaultValue);
};
const checkSomeValueEqual = (object, defaultValue) => {
    return Object.values(object).some((value) => value === defaultValue);
};

const downloadFile = (data, name = 'file', type = 'text/plain') => {
    const { URL: { createObjectURL, revokeObjectURL }, setTimeout, } = window;
    const blob = base64ToBlob(data, type);
    const url = createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.setAttribute('href', url);
    anchor.setAttribute('download', name);
    anchor.click();
    setTimeout(() => {
        revokeObjectURL(url);
    }, 100);
};

const camelCase = text => {
    if (!text.length) {
        return text;
    }
    const onMatch = (word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        const charAt = word.charAt(0).toLowerCase();
        if (word.length > 1) {
            return `${charAt}${word.slice(1).toLowerCase()}`;
        }
        return word;
    };
    return text
        .split(/[_-\s]+/)
        .map(onMatch)
        .join('');
};

const toTitleCase = (text, separator = ' ') => {
    if (text.length <= 1 || !text.includes(separator)) {
        return text;
    }
    let titleCase = text.toLowerCase();
    const split = text.split(separator);
    const { length } = split;
    for (let index = 0; index < length; index += 1) {
        const char = split[index].charAt(0);
        titleCase = titleCase.replace(char, char.toUpperCase());
    }
    return titleCase;
};

const toRem = (pixels) => `${pixels / 16}rem`;

export { base64ToBlob, between, camelCase, capitalize, checkEveryValueEqual, checkSomeValueEqual, downloadFile, fileToBase64, formatStr, getFirstTwoLetters, getFreshChatLink, getNestedObject, hasKey as hasKeys, isValueNil, logToFile, keys as objectKeys, paddingLeft, sortAsc, sortDesc, toRem, toTitleCase, treatNFe, index as validateCNH, ValidateCNPJ as validateCNPJ, validarCPF as validateCPF, validateChaveAcesso, ValidateEmail as validateEmail, validateRenavam };
